<script setup lang="ts">
import { iIcon } from '@inscribe/signal';

/** Props */
const props = defineProps<{
  title: string;
  description: string;
}>();
</script>

<template>
  <div
    class="decision-engine-item-description d-flex flex-row align-items-start i-gap-6 i-radius-2xl i-p-10"
  >
    <i-icon symbol="small_solid_info" :size="16" class="info-icon i-mt-1" />
    <div class="description d-flex flex-column i-gap-1">
      <div class="title i-text-button-2">
        {{ title }}
      </div>
      <div class="subtitle i-text-body-2">
        {{ description }}
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.decision-engine-item-description {
  background-color: var(--surface-neutral-subtle);

  .info-icon {
    color: var(--icon-neutral-subtle);
  }

  .description {
    width: 100%;

    .subtitle {
      width: 70%;
    }
  }
}
</style>
